import { useEffect, useState } from 'react';

// Styles
import styles from './index.module.sass';

export default function OrderCard({
  children,
  title,
  open = true,
  icon = '',
  iconColor = '',
  iconText = '',
  iconSize = 24,
  callback,
}) {
  const [isOpen, setIsOpen] = useState(open);

  function handleClick() {
    if (callback) callback(!isOpen);
    else setIsOpen(!isOpen);
  }

  useEffect(() => {
    setIsOpen(open);
  }, [open]);
  return (
    <div id={styles.OrderCard}>
      {title && (
        <div className={styles.header}>
          <div className={styles.cardTitle}>{title}</div>
          <div className={styles.iconContainer} onClick={handleClick}>
            <i
              className={`material-icons ${styles.icon} ${styles[iconColor]}`}
              style={{ fontSize: iconSize }}>
              {(icon && icon) || (isOpen && 'expand_less') || 'expand_more'}
            </i>
            {iconText && <span className={`${styles[iconColor]}`}>{iconText}</span>}
          </div>
        </div>
      )}
      {isOpen && children}
    </div>
  );
}
